import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from '../../../providers/auth.service';
import { SharedClientService } from '../shared/services/shared-client.service';


export class BillingGuardService implements CanActivate {
	constructor(
		private authService: AuthService,
		private clientService: SharedClientService) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		return this.clientService.get(this.authService.userId)
			.map((client) => {
				if (client.status !== 'current-client|not-approved' && client.status !== 'past-client|declined') {
					return true;
				}

				window.location.assign('/');
				return false;
			})
			.catch((error) => {
				window.location.assign('/');
				return Observable.of(false);
			});
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/billing-guard.service.ts